export default __webpack_public_path__ + "static/media/medical_21.8d65eb42.jpg";